import React from 'react';
import { Alert, Box, Button, Typography, useMediaQuery } from '@mui/material';
import { DialogActions, DialogContent } from '../dialogs';
import { Dialog } from './dialog';
import { theme } from '../../configs';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface FeedbackDialogProps {
  visible?: boolean;
  setVisible?: (value: boolean) => void;
}
export const FeedbackSuccessDialog = (props: FeedbackDialogProps) => {
  const { visible = false, setVisible = () => {} } = props;
  const down_sm = useMediaQuery(theme.breakpoints.down('sm'));

  const onClose = () => {
    setVisible(false);
  };

  return (
    <Dialog open={visible} onClose={onClose} fullScreen={down_sm}>
      <DialogContent>
        <Alert severity="success" variant="filled" icon={<CheckCircleIcon />} sx={{ mb: 6 }}>
          Your service has been requested
        </Alert>

        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography variant={'subtitle2'} sx={{ fontWeight: 'bold' }}>
            One of our cleaning professionals will be dispatched to this zone momentarily
          </Typography>
        </Box>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography variant="subtitle2">Below are some recently serviced zones near you</Typography>
          {/* todo: list out the recently created zones */}
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button startIcon={<CloseIcon />} color="primary" sx={{ marginTop: 1 }} onClick={() => setVisible(false)}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
